// extracted by mini-css-extract-plugin
export default {"container":"Event_container__JBzzm","topContainer":"Event_topContainer__HZ5y5","title":"Event_title__p3O69","date":"Event_date__xyfrL"};